import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import CenterContent from '../Components/CenterContent/CenterContent'
import InstrumentsWrrapper from '../Components/InstrumentsWrrapper/InstrumentsWrrapper'
import { observer } from 'mobx-react-lite'
import { student } from '../store/student.ts'
import ApplicaionsDone from './../block/applications/ApplicationsDone'
import { report } from './../store/report'
import CheckBox from '../Components/CheckBox/CheckBox'
import http from './../Service/http'
import { direction } from '../store/direction'
import { IoMdThermometer } from 'react-icons/io'
import EmbassiesModal from '../Components/Modal/EmbassiesModal'
import SocialFundModal from '../Components/Modal/SocialFundModal'
import AboutLearningModal from '../Components/Modal/AboutLearningModal'
import AboutLearningModalKGMA from '../Components/Modal/AboutLearningModalKGMA'
// import BlueBtn from "../Components/SidBarButtons/BlueBtn";
// import Input from "react-select/dist/declarations/src/components/Input";
import { auth } from '../store/auth'
import { toast } from 'react-toastify'
import CallModal from '../Components/Modal/CallModal'
import SpravkaFinishingModal from '../Components/Modal/SpravkaFinishingModal'
import ReactPaginate from 'react-paginate'
import '../Styles/pagination.css'
import ArchiveModal from '../Components/Modal/ArchiveModal'
import ArchiveORTModal from '../Components/Modal/ArchiveORTModal'
import TemporaryСertificateModal from '../Components/Modal/TemporaryСertificateModal'
import AboutLearningResidentsModal from '../Components/Modal/AboutLearningResidentsModal'
import Selector from '../Components/Select/Select'
import { getReportType } from '../Service/report'


export const ApplicationContainer = observer(function () {
	const [form, setForm] = useState(false)
	const [embassies, setEmbassies] = useState(false)
	const [openSocial, setSocial] = useState(false)
	const [archive, setArchive] = useState(false)
	const [openLearn, setLearn] = useState(false)
	const { t, i18n } = useTranslation()
	const [isIspol, setIsIspol] = useState(false)
	const [currentPage, setCurrentPage] = useState(0);
const [reportType, setReportType] = useState({
		label: 'Все',
		value: 0
	})
    const ITEMS_PER_PAGE = 25;
    const handlePageChange = ({ selected }) => {
        setCurrentPage(selected);
    };

    const pageCount = Math.ceil(report.reportExpected.length / ITEMS_PER_PAGE);

    const paginatedDisciplines = report.reportExpected.slice(currentPage * ITEMS_PER_PAGE, (currentPage + 1) * ITEMS_PER_PAGE);
	const getReport = async () => {
		const res = await getReportType()
		report.newReportTypes(res)
	}
	useEffect(() => {
		getReport()
	}, [])

	// useEffect(() => {
	// 	if (direction.leftOrRight == 'left') {
	// 		getReports()
	// 	}
	// }, [direction.leftOrRight])

	const getReports = async (id) => {
		const a = await http.post('/report/reportApplicationWait?reportType=' + id)
		report.newReport(a.data.reportApplicationWait)
	}
	
	useEffect(() => {
		if(reportType?.value!==0 && direction.leftOrRight == 'left' ){
			getReports(reportType?.value)
		}else if(direction.leftOrRight == 'left' ){
			getReports()
		}
	}, [form,
		embassies,
		openSocial,
		archive,
		openLearn,reportType,direction.leftOrRight])

	const openForm = () => {
		setForm(!form)
		setEmbassies(!embassies)
		setSocial(!openSocial)
		setArchive(!archive)
		setLearn(!openLearn)
	}

	const ispolnitelUpdate = async () => {
		const res = await http.post('/okno/ispolnitelStatus', {
			id_zakaz: student.student.id_okno_zakaz,
			AVN_operator: auth.user.data.id,
			doc: student.student.id_okno_document
		})
		if (res.data.result !== null) {
			toast(res.data.result)
			getReports()
			setIsIspol(false)
		}
	}
	useEffect(() => {
		if (isIspol) {
			ispolnitelUpdate()
		}
	}, [isIspol])

	return (
		<CenterContent>
			<InstrumentsWrrapper
				leftHead={t('st:instrument.titles.appsExpected')}
				rightHead={t('st:instrument.titles.doneApps')}
				leftChilds={
					<div style={{ margin: '0 auto', width: '100%', display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }}>
				<Selector
					options={[
						{
							value: 0,
							label: 'Все'
						},
						...report.reportTypes
					]}
					value={reportType}
					placeholder={'Выберите!'}
					onChange={setReportType}
					isSearchable={true}
					isDisabled={false}
					isClearable={false}
					title={''}
					name={'search'}
					withBorder={true}
				/>
			</div>
				}
				rightChilds={<ApplicaionsDone />}
			/>
			<div className='TableWrapper'>
				<table>
					<thead>
						<tr>
							<th style={{ width: '5%' }}>№</th>
							<th style={{ width: '35%', textAlign: 'left' }}>{t('st:table.fio')}</th>
							<th style={{ width: '15%' }}>{t('st:appTitle.titles.executor')}</th>
							<th style={{ width: '15%' }}>{t('st:appTitle.titles.group')}</th>
							<th style={{ width: '15%' }}>{t('st:appTitle.titles.doc')}</th>
							<th style={{ width: '10%', textAlign: 'center' }}>{t('st:appTitle.titles.number')}</th>
							<th style={{ width: '15%' }}>{t('st:appTitle.titles.type')}</th>
							<th style={{ width: '15%' }}>{t('st:appTitle.titles.dateApp')}</th>
							{direction.leftOrRight == 'left' ? (
								<th style={{ width: '10%' }}>{t('st:appTitle.titles.status')}</th>
							) : (
								<th style={{ width: '10%' }}>{t('st:appTitle.titles.doned')}</th>
							)}
							{direction.leftOrRight == 'left' ? (
								<th style={{ width: '10%' }}>{t('st:appTitle.titles.esp')}</th>
							) : (
								<th style={{ width: '10%' }}>{t('st:appTitle.titles.doned')}</th>
							)}
						</tr>
					</thead>
					<tbody>
						{paginatedDisciplines.map((item, index) => {
							return (
								<tr
									onClick={() => {
										student.newStudent(item)
									}}
								>
									<td>{index + 1 + currentPage * ITEMS_PER_PAGE}</td>
									<td style={{ textAlign: 'left' }}>{item.s_fio}</td>
									{item.status_new === false ? (
										<td onClick={() => setIsIspol(true)} style={{ color: '#2f80ed', fontWeight: 'bold' }}>
											{item.ispolnitel}
										</td>
									) : (
										<td>{item.ispolnitel}</td>
									)}
									<td>{item.groups}</td>
									{item.status_new === true ? (
										<td onClick={openForm} style={{ color: '#2f80ed', fontWeight: 'bold' }}>
											{item.okno_document}
										</td>
									) : (
										<td>{item.okno_document}</td>
									)}
									<td>{item.reference_number}</td>

									<td>{item.status_online_offline}</td>
									<td>{item.date_insert}</td>

									{direction.leftOrRight == 'left' ? (
										<td>
											{item.date_viewed ? (
												<CheckBox
													onchange={async e => {
														const res = await http.post('/report/reportApplicationUpdate', {
															id_okno_zakaz: item.id_okno_zakaz,
															id_okno_document: item.id_okno_document,
															status: 1,
														})
														if (res.data.result === 'Заявка выполнено') {
															getReports(report.currentType)
														}
													}}
													checked={item.status === true ? true :false }
													item={item}
													active={true}
													dsbl={false}
													name=''
													styles={{  display: 'inline-block', verticalAlign: 'middle', width: '17px'  }}
												/>
											) : (
												<p className='new_report'>Новый</p>
											)}
										</td>
									) : (
										<td>
											<p className='new_report' style={{ fontWeight: 400 }}>
												{item.date_viewed}
											</p>
										</td>
									)}

									{direction.leftOrRight == 'left' ? (
										<td>
											{item.date_viewed ? (
												<CheckBox
													onchange={async e => {
														const res = await http.post('/report/reportApplicationEdsUpdate', {
															id_okno_zakaz: item.id_okno_zakaz,
															id_okno_document: item.id_okno_document,
															status: 1,
															EDS: 1
														})
														if (res.data.result === 'Заявка отправлено на подпись') {
															getReports(report.currentType)
														}
													}}
													checked={item.EDS}
													item={item}
													active={true}
													dsbl={false}
													name=''
													styles={{  display: 'inline-block', verticalAlign: 'middle', width: '17px'  }}

												/>
											) : (
												<p className='new_report'>Новый</p>
											)}
										</td>
									) : (
										<td>
											<p className='new_report' style={{ fontWeight: 400 }}>
												{item.date_viewed}
											</p>
										</td>
									)}
								</tr>
							)
						})}
					</tbody>
				</table>
				{pageCount > 1 && (
                    <ReactPaginate
                        pageCount={pageCount}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageChange}
                        containerClassName={'pagination'}
                        activeClassName={'active'}
                        previousLabel={'Previous'}
                        nextLabel={'Next'}
                        breakLabel={'...'}
                    />
                )}
				{student.student.id_okno_document === 10 ? embassies && <EmbassiesModal openForm={openForm} /> : null}
				{student.student.id_okno_document === 3 ? openSocial && <SocialFundModal openForm={openForm} /> : null}
				{student.student.id_okno_document === 4 ? openLearn && <AboutLearningModal openForm={openForm} /> : null}
				{student.student.id_okno_document === 13 ? openLearn && <AboutLearningModalKGMA openForm={openForm} /> : null}
				{student.student.id_okno_document === 9 ? openLearn && <CallModal openForm={openForm} /> : null}
				{student.student.id_okno_document === 5 ? openLearn && <SpravkaFinishingModal openForm={openForm} /> : null}
				{student.student.id_okno_document === 8 ? openLearn && <ArchiveModal openForm={openForm} /> : null}
				{student.student.id_okno_document === 14 ? openLearn && <ArchiveORTModal openForm={openForm} /> : null}
				{student.student.id_okno_document === 11 ? openLearn && <TemporaryСertificateModal openForm={openForm} /> : null}
				{student.student.id_okno_document === 12 ? openLearn && <AboutLearningResidentsModal openForm={openForm} /> : null}
				{student.student.id_okno_document !== 10 &&
					student.student.id_okno_document !== 3 &&
					student.student.id_okno_document !== 4 &&
					student.student.id_okno_document !== 13 &&
					student.student.id_okno_document !== 9 &&
					student.student.id_okno_document !== 8 &&
					student.student.id_okno_document !== 14 &&
					student.student.id_okno_document !== 11 &&
					student.student.id_okno_document !== 12 &&
					student.student.id_okno_document !== 5
						? form && <AboutLearningModal openForm={openForm} />
						: null}
			</div>
		</CenterContent>
	)
})
